export const PROFILE_KEYS = [
  'normal',
  'cofae',
  'customer_service',
  'controller',
  'administrator',
];
export const ATTENTION_KEYS = [
  'unattended',
  'follow_up',
  'no_exchange',
  'external_reply',
];

export const reportParams = filters =>
  Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== '' && value != null)
  );

export const pendingHours = (pendingSince, referenceTime) => {
  if (!pendingSince) return null;
  const hours = (new Date(referenceTime) - new Date(pendingSince)) / 3600000;
  return Number.isFinite(hours) ? Math.max(0, hours) : null;
};
